"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var deleteConversations_1 = require("./deleteConversations");
var deleteItems_1 = require("./deleteItems");
var blockLastSendersHelper_1 = require("./helpers/blockLastSendersHelper");
var getSweepableMailboxes_1 = require("./helpers/getSweepableMailboxes");
var getUniqueConversationContextsForRowKey_1 = require("./helpers/getUniqueConversationContextsForRowKey");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_trace_1 = require("owa-trace");
var legacy_1 = require("satcheljs/lib/legacy");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
/**
 * Block the smtp addresses from given rows
 * @param rowKeys the row keys
 * @param tableView the table view
 * @param actionSource the action source that triggers the block action
 */
function blockLastSendersFromTable(rowKeys, tableView, actionSource) {
    if (!rowKeys || rowKeys.length == 0) {
        owa_trace_1.trace.error('Block button should not be exposed when there is nothing selected in list view.');
        return;
    }
    // Get de-duped mailboxes
    var mailboxes = getSweepableMailboxes_1.getSweepableMailboxesFromRowKeys(rowKeys, tableView);
    blockLastSendersHelper_1.default(mailboxes, function () {
        deleteRowsUponBlocking(rowKeys, tableView, actionSource);
    });
}
exports.default = blockLastSendersFromTable;
/**
 * Delete the rows after the block last senders
 * @param rowKeys of the rows where the last senders are retrieved from
 * @param tableView that contains the rows
 */
var deleteRowsUponBlocking = legacy_1.action('deleteRowsUponBlocking', datapoints_1.default.blockSendersFromTableDatapoint)(function deleteRowsUponBlocking(rowKeys, tableView, actionSource) {
    // Since conversations may have been deleted from the table while the confirm dialog was open,
    // we need to validate the conversation rowKeys again before performing delete
    var filteredRowKeys = rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
    var disposableType = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')
        ? 'HardDelete'
        : 'MoveToDeletedItems';
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var conversationActionContexts = getUniqueConversationContextsForRowKey_1.default(filteredRowKeys, tableView.id);
            // VSO: 20069: [Discussion] Block Senders on a conversation
            // Permanently delete selected emails
            deleteConversations_1.deleteConversationsWithoutConfirmDialog(conversationActionContexts, tableView.id, disposableType, instrumentationContexts, 'NonUserAction' /* actionSource */);
            break;
        case 1 /* Message */:
            var itemIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, tableView.id);
            deleteItems_1.deleteItemsWithoutConfirmDialog(itemIdStrings, disposableType, tableView.tableQuery.folderId, 'NonUserAction' /* actionSource */, instrumentationContexts, null /* requestInitOptions */);
            break;
    }
});
//# sourceMappingURL=blockLastSendersFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/blockLastSendersFromTable.js
// module id = 5662
// module chunks = 62